import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
import "./TemplateDeleteModal.css";

export default function TemplateDeleteModal({ toggleShowDeleteModal, handleDeleteTemplate, open }) {
  return (
    <Modal
      open={open}
      destroyOnClose
      closable={false}
      centered
      footer={null}
      onCancel={toggleShowDeleteModal}
      width={368}
      wrapClassName="TemplateDeleteModal"
      className="TemplateDeleteModal"
    >
      <div className="deleteModal">
        <div className="deleteModalSpanContainer">
          <span className="deleteModalHeader"> Delete report </span>
          <span className="deleteModalBody"> Are you sure you want to delete this report? </span>
        </div>
        <div className="deleteModalButtonContainer">
          <Button type="default" onClick={toggleShowDeleteModal}>Cancel</Button>
          <Button type="primary" onClick={() => { toggleShowDeleteModal(); handleDeleteTemplate(); }}>Delete</Button>
        </div>

      </div>
    </Modal>
  );
}
